import CreateShareableLinkProvider from './CreateShareableLink.provider';

export default CreateShareableLinkProvider;
